import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Activity, Topic} from '../models/event';

@Injectable({
  providedIn: 'root'
})
export class PreviewService {

  constructor (
    private db: AngularFirestore,
  ) { }

  selectActivityByDay (day_id) {

    return this.db.collection<Activity>('sbccv_event_activities', ref => ref
      .where('day_id', '==', day_id)
      .where('deleted', '==', false)).snapshotChanges()
      .subscribe((result) => {
       const activities: any[] = result.map(item => {
          let day = new Activity();
          day.id = item.payload.doc.id;
          day.event_id = item.payload.doc.data().event_id;
          day.day_id = item.payload.doc.data().day_id;
          day.name = item.payload.doc.data().name;
          day.date = item.payload.doc.data().date;
          day.startTime = item.payload.doc.data().startTime;
          day.location = item.payload.doc.data().location;
          day.text = item.payload.doc.data().text;
          //  day.team = item.payload.doc.data().team;
          day.materials = item.payload.doc.data().materials;

          day.sponsors = item.payload.doc.data().sponsors;

          return day;
        });

        activities.sort(this.compareActivities)

      })
  }


  async selectTopicByActivity (activity_id) {

    const topicsByActivityPromise = new Promise((resolve) => {

      this.db.collection<Topic>('sbccv_event_topics', ref => ref
        .where('activity_id', '==', activity_id)
        .where('deleted', '==', false)).snapshotChanges()
        .subscribe((result) => {
          const topics: Topic[] = result.map(item => {
            let topic = new Topic();
            topic.id = item.payload.doc.id;
            topic.event_id = item.payload.doc.data().event_id;
            topic.day_id = item.payload.doc.data().day_id;
            topic.activity_id = item.payload.doc.data().activity_id;
            topic.name = item.payload.doc.data().name;
            topic.date = item.payload.doc.data().date;
            topic.text = item.payload.doc.data().text;
            topic.startTime = item.payload.doc.data().startTime;
            topic.duration = item.payload.doc.data().duration;
            topic.materials = item.payload.doc.data().materials;
            topic.sponsor_name = item.payload.doc.data().sponsor_name;
            topic.sponsor_id = item.payload.doc.data().sponsor_id;
            topic.banner = item.payload.doc.data().banner;
            topic.text1 = item.payload.doc.data().text1 || '';
            topic.text2 = item.payload.doc.data().text2 || '';
            topic.text3 = item.payload.doc.data().text3 || '';
            return topic;
          });

          topics.sort(this.compareTopics)
          resolve(topics)
        })
    })

    const agendaByActivityPromise = new Promise((resolve) => {

      this.db.collection<Topic>('sbccv_agenda', ref => ref
        .where('activity_id', '==', activity_id)).snapshotChanges()
        .subscribe((result) => {
          const agenda: any[]= result.map(item => {
            let ag: any = {};
            ag.id = item.payload.doc.id;
            ag = item.payload.doc.data();
            return ag;
          });

       //   this.agenda.sort(this.compareTopics)
          resolve(agenda)
        })
    })

    return (await Promise.all([ topicsByActivityPromise, agendaByActivityPromise ]));

  }


  compareActivities (a, b) {
    const pa = String(a.startTime)
    const pb = String(b.startTime)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }

  compareTopics (a, b) {

    const pa = String(a.startTime)
    const pb = String(b.startTime)

    if (pa > pb) return 1;
    if (pb > pa) return -1;

    return 0;
  }


}
